import React from 'react';
import { techStack } from '../data/portfolio';
import './Skills.css';

const Skills = () => {
  const categories = [...new Set(techStack.map(tech => tech.category))];
  const getCategoryTechs = (category) => techStack.filter(tech => tech.category === category);



  
  return (
    <section id="skills" className="skills section" aria-labelledby="skills-heading">
      <div className="container">
        <header className="section-header" data-eyebrow="Skills">
          <h2 id="skills-heading" className="section-title">Technical Skills</h2>
          <p className="section-subtitle">Technologies and tools I use to build and ship mobile apps</p>
        </header>

        <div className="skills__categories">
          {categories.map((category) => (
            <div key={category} className="skills__category">
              <h3 className="skills__category-title">
                <span className="skills__category-icon" aria-hidden="true">{getCategoryIcon(category)}</span>
                {category}
              </h3>
              <div className="skills__grid">
                {getCategoryTechs(category).map((tech) => (
                  <div key={tech.name} className="skills__item" style={{ '--proficiency': `${tech.proficiency}%` }}>
                    <div className="skills__item-header">
                      <span className="skills__item-icon" aria-hidden="true">{getTechIcon(tech.name)}</span>
                      <span className="skills__item-name">{tech.name}</span>
                      <span className="skills__proficiency">{tech.proficiency}%</span>
                    </div>
                    <div className="skills__progress" role="progressbar" aria-valuenow={tech.proficiency} aria-valuemin={0} aria-valuemax={100} aria-label={`${tech.name} proficiency`}>
                      <div className="skills__progress-bar" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="skills__highlight">
          <h3 className="skills__highlight-title">Core Competencies</h3>
          <div className="skills__highlight-grid">
            <div className="skills__highlight-card">
              <div className="skills__highlight-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" />
                </svg>
              </div>
              <h4 className="skills__highlight-name">Cross-Platform Mobile</h4>
              <p className="skills__highlight-desc">Building iOS &amp; Android apps from a single React Native codebase</p>
            </div>
            <div className="skills__highlight-card">
              <div className="skills__highlight-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h4 className="skills__highlight-name">CI/CD &amp; Automation</h4>
              <p className="skills__highlight-desc">EAS Build/Submit and GitHub Actions for automated builds and store releases</p>
            </div>
            <div className="skills__highlight-card">
              <div className="skills__highlight-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                </svg>
              </div>
              <h4 className="skills__highlight-name">Realtime Features</h4>
              <p className="skills__highlight-desc">Chat and voice/video calling built on WebSockets and AWS AppSync</p>
            </div>
            <div className="skills__highlight-card">
              <div className="skills__highlight-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
                </svg>
              </div>
              <h4 className="skills__highlight-name">Performance Optimization</h4>
              <p className="skills__highlight-desc">Smooth animations, bundle size, and startup time tuning</p>
            </div>
            <div className="skills__highlight-card">
              <div className="skills__highlight-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h4 className="skills__highlight-name">Serverless AWS</h4>
              <p className="skills__highlight-desc">Amplify, AppSync, Cognito, Lambda, DynamoDB, and S3 as a production backend</p>
            </div>
            <div className="skills__highlight-card">
              <div className="skills__highlight-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                </svg>
              </div>
              <h4 className="skills__highlight-name">Offline-First Sync</h4>
              <p className="skills__highlight-desc">Local storage and reliable sync for spotty or offline connections</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const getCategoryIcon = (category) => {
  const icons = {
    'Languages & Frameworks': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></svg>,
    'AWS Cloud': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>,
    'APIs & Realtime': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>,
    'Data & Storage': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" /></svg>,
    'Notifications': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>,
    'Delivery': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
  };
  return icons[category] || icons['Delivery'];
};

const getTechIcon = (name) => {
  const icons = {
    'React Native': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></svg>,
    'React': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="3" /></svg>,
    'JavaScript': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" /></svg>,
    'TypeScript': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 3l-5 5M12 3l5 5M7 3l5 5" /></svg>,
    'Git/GitHub': <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="18" r="3" /><circle cx="6" cy="6" r="3" /><path d="M13 6h3a2 2 0 0 1 2 2v7M7 18H4a2 2 0 0 1-2-2V9" /></svg>,
  };
  return icons[name] || (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 1 1 3 2.45c-.7.2-1.5.75-1.5 1.55" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
};

export default Skills;
